import { useEffect } from 'react';
import safeAwait from 'safe-await';

import { AnalyticsEvent } from '../../../../constants/AnalyticsEvent';
import { LogEventPayload } from '../../../../redux/actions/analyticsLog';
import sensors from '../../../../utils/analytics/sensors';
import { Settings } from '../../../../utils/packages/fbsdk';
import {
  PERMISSIONS,
  RESULTS,
  check,
  request,
} from '../../../../utils/RNPermission';

interface Props {
  canShowATTPopup: boolean;
  checkDone: () => void;
  logEvent: (payload: LogEventPayload) => void;
}

const setIsTrackAllowed = (isAllow: boolean) => {
  sensors.profileSet({ is_allow_tracking: isAllow });
  Settings.setAdvertiserTrackingEnabled(isAllow);
};

export default function TrackingTransparencyPermission(props: Readonly<Props>) {
  const { canShowATTPopup, checkDone, logEvent } = props;

  useEffect(() => {
    const sendATTRequestResultEvent = (isAllow: boolean) => {
      if (!isAllow) {
        return;
      }

      logEvent({
        logEvent: AnalyticsEvent.AllowTrackingRequest,
      });
    };
    const handleTrackingTransparencyPermission = async () => {
      const permission = PERMISSIONS.IOS.APP_TRACKING_TRANSPARENCY;
      const [error, checkResult] = await safeAwait(check(permission));

      if (error || checkResult !== RESULTS.DENIED) {
        setIsTrackAllowed(checkResult === RESULTS.GRANTED);

        return checkDone();
      }

      const [, requestResult] = await safeAwait(request(permission));

      if (requestResult) {
        const isAllow = requestResult === RESULTS.GRANTED;

        sendATTRequestResultEvent(isAllow);
        setIsTrackAllowed(isAllow);
      }

      checkDone();
    };

    if (canShowATTPopup) {
      handleTrackingTransparencyPermission().catch(console.log);
    } else {
      checkDone();
    }
  }, []);

  return null;
}
